import { getMeInfo } from "../services/auth.service";

const USER_KEY = "user";

export const setUser = (user: any) => {
  localStorage.setItem(USER_KEY, JSON.stringify(user));
};

export const removeUser = () => {
  localStorage.removeItem(USER_KEY);
};

export const getUser = () => {
  const user = localStorage.getItem(USER_KEY);
  if (user === null || user === "undefined" || !user) {
    return null;
  } else {
    return JSON.parse(user);
  }
};

export const fetchMe = async () => {
  try {
    const { data } = await getMeInfo();
    if (data?.success) {
      setUser(data?.data?.admin);
      window.dispatchEvent(new Event("storage"));
    }
  } catch (error) {}
};
